import Deposit from './Deposit';

export default Deposit;
